import React = require('react')
import { ReactNode } from 'react'

export const MainLayout = ({
  children,
  className,
  inert
}: {
  children: ReactNode
  className: string
  inert: boolean
}) => (
  <main id="a11y-main" className={className} {...(inert ? { inert: '' } : {})}>
    {children}
  </main>
)
